import { gql } from '@apollo/client'

export default gql(`
    mutation createPublishingGroup( $name: String! $project: String) {
        createPublishingGroup(
            input: {
                name: $name
            }
            project: $project
        ) {
            id
            name
            status
            isDefault
            isEnvironment
            countries
        }
    }`
)
